import { useParams, Navigate } from "react-router-dom"

export default function RefPage() {

  const params = useParams()

  localStorage.setItem('referal', params.ref || 'none')
  
  return (
    <div>
      <Navigate to="/" />
    </div>
  )
}